import { MutationTree } from 'vuex'
import { ModalState } from '../types'
import toggleModal from './toggleModal'

const mutations: MutationTree<ModalState> = { toggleModal }

export default mutations
